import { publicExperienceApiUrl } from '../config/api';
import publicExperienceFallback from '../config/publicExperienceFallback';

const isRecord = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const clone = (value) => JSON.parse(JSON.stringify(value));

const LEGACY_STORY_TEXT =
  'A Glace nasceu do desejo de transformar o brownie do dia a dia em um gesto de afeto. Entre fornadas, testes e embalagens pensadas com carinho, fomos criando uma confeitaria que mistura sabor intenso, textura macia e um olhar delicado para presentear.\n\nHoje cada caixa sai da nossa cozinha com o mesmo cuidado do comeco: ingredientes selecionados, acabamento artesanal e a vontade de fazer cada pedido chegar com cara de momento especial.';

const ACCENTED_STORY_TEXT =
  'A Glac\u00ea nasceu do desejo de transformar o brownie do dia a dia em um gesto de afeto. Entre fornadas, testes e embalagens pensadas com carinho, fomos criando uma confeitaria que mistura sabor intenso, textura macia e um olhar delicado para presentear.\n\nHoje cada caixa sai da nossa cozinha com o mesmo cuidado do come\u00e7o: ingredientes selecionados, acabamento artesanal e a vontade de fazer cada pedido chegar com cara de momento especial.';

const normalizeLookupKey = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

const KNOWN_TEXT_REPLACEMENTS = new Map([
  ['inicio', 'In\u00edcio'],
  ['cardapio', 'Card\u00e1pio'],
  ['ver cardapio', 'Ver Card\u00e1pio'],
  ['nossa historia', 'Nossa hist\u00f3ria'],
  ['uma receita feita para virar memoria', 'Uma receita feita para virar mem\u00f3ria'],
  [
    normalizeLookupKey(
      'Escolha, personalize e continue seu atendimento pelo WhatsApp com o pedido ja registrado.',
    ),
    'Escolha, personalize e continue seu atendimento pelo WhatsApp com o pedido j\u00e1 registrado.',
  ],
  [normalizeLookupKey(LEGACY_STORY_TEXT), ACCENTED_STORY_TEXT],
]);

const normalizeKnownText = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  const normalizedValue = value
    .replace(/Ã¡/g, '\u00e1')
    .replace(/Ã©/g, '\u00e9')
    .replace(/Ãª/g, '\u00ea')
    .replace(/Ã­/g, '\u00ed')
    .replace(/Ã³/g, '\u00f3')
    .replace(/Ãº/g, '\u00fa')
    .replace(/Ã£/g, '\u00e3')
    .replace(/Ãµ/g, '\u00f5')
    .replace(/Ã§/g, '\u00e7');
  const replacement = KNOWN_TEXT_REPLACEMENTS.get(normalizeLookupKey(normalizedValue));

  return replacement || normalizedValue;
};

const mergeDeep = (base, patch) => {
  if (patch === undefined) {
    return clone(base);
  }

  if (Array.isArray(base) && Array.isArray(patch)) {
    return clone(patch);
  }

  if (isRecord(base) && isRecord(patch)) {
    const merged = {};
    const keys = new Set([...Object.keys(base), ...Object.keys(patch)]);

    keys.forEach((key) => {
      merged[key] = mergeDeep(base[key], patch[key]);
    });

    return merged;
  }

  return clone(patch);
};

const normalizeContractContent = (experience) => {
  const normalized = clone(experience);
  const header = normalized?.data?.navigation?.header;
  const primaryCta = normalized?.data?.navigation?.primaryCta;
  const home = normalized?.data?.pages?.home;

  if (Array.isArray(header)) {
    normalized.data.navigation.header = header.map((link) => ({
      ...link,
      label: normalizeKnownText(link?.label),
    }));
  }

  if (primaryCta) {
    normalized.data.navigation.primaryCta = {
      ...primaryCta,
      label: normalizeKnownText(primaryCta?.label),
    };
  }

  if (home?.hero) {
    normalized.data.pages.home.hero = {
      ...home.hero,
      eyebrow: normalizeKnownText(home.hero?.eyebrow),
      headline: normalizeKnownText(home.hero?.headline),
      supportingText: normalizeKnownText(home.hero?.supportingText),
      cta: home.hero?.cta
        ? {
            ...home.hero.cta,
            label: normalizeKnownText(home.hero.cta?.label),
          }
        : home.hero?.cta,
    };
  }

  if (home?.story) {
    normalized.data.pages.home.story = {
      ...home.story,
      eyebrow: normalizeKnownText(home.story?.eyebrow),
      title: normalizeKnownText(home.story?.title),
      text: normalizeKnownText(home.story?.text),
    };
  }

  return normalized;
};

const normalizeContractShape = (payload) => {
  const rawContract = isRecord(payload?.data) ? payload.data : payload;
  return normalizeContractContent(mergeDeep(publicExperienceFallback, rawContract));
};

export const getFallbackPublicExperience = () => clone(publicExperienceFallback);

export const fetchPublicExperience = async () => {
  try {
    const response = await fetch(publicExperienceApiUrl);

    if (!response.ok) {
      throw new Error(response.statusText || 'Erro ao carregar configuração pública.');
    }

    const payload = await response.json();

    return {
      experience: normalizeContractShape(payload),
      source: 'api',
    };
  } catch (error) {
    console.error('Erro ao carregar public experience:', error);

    return {
      experience: getFallbackPublicExperience(),
      source: 'fallback',
    };
  }
};
